import * as React from 'react';
import { ArticleHeading4, Responsive } from '@cian/ui-kit';

import { ILabel } from '../../types/labels';
import * as style from './styles.css';
import { isTitleVisible } from './utils/isTitleVisible';

export interface ICommentProps {
  title?: string;
  label?: ILabel;
  isQuestion?: boolean;
  isBuilder?: boolean;
  isLegacy?: boolean;
  isMobile?: boolean;
  children: React.ReactElement<any>;
}

export const Comment: React.FC<ICommentProps> = ({
  title,
  label,
  children,
  isQuestion = false,
  isBuilder = false,
  isLegacy = false,
  isMobile = false,
}) => {
  const isTitleShown = isTitleVisible({
    title,
    label,
    isQuestion,
    isBuilder,
    isLegacy,
    isMobile,
  });

  return (
    <div data-testid="Comment" className={style['container']}>
      <Responsive desktop>
        {isTitleShown && (
          <div className={style['title']}>
            <ArticleHeading4>{title}</ArticleHeading4>
            {!!label && (
              <div className={style['label']} style={{ backgroundColor: label.color }}>
                {label.text}
              </div>
            )}
          </div>
        )}
      </Responsive>
      <Responsive tablet phone>
        {isTitleShown && (
          <div className={style['title']}>
            {!!title && <ArticleHeading4>{title}</ArticleHeading4>}
            {!!label && (
              <div className={style['label']} style={{ backgroundColor: label.color }}>
                {label.text}
              </div>
            )}
          </div>
        )}
      </Responsive>
      <div className={style['message']}>{children}</div>
    </div>
  );
};
